// format float with USD money format
const moneyFormat = ( value ) => {
    var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });
    return formatter.format(value);
}

export default moneyFormat;